export default __webpack_public_path__ + "static/media/wallet-icon.7577e856.svg";